export class QrCodeResponse {
  display: boolean;
  type: string;
  data: string;
  verifyCode: string;
}
